<template>
    <div :class="['row plan-card', { active: activePrice == plan.id }]" >
        <div class="col-8 text-left">
            <p class="mb-2">
                <strong>{{ plan.name }}</strong><span v-if="plan.price_cicle == 12"  class="ml-2 small--text"><strong> Plano Anual</strong></span>
            </p>
        </div>

        <div v-if="change" class="col-4 text-right">
            <p class="mb-2">
                <strong class="theme-color small--text--clean">Trocar</strong>
            </p>
        </div>

        <div class="col-12 small--text--clean" >
            <p>{{plan.description}}</p>
        </div>
            
    </div>
</template>

<script>
export default {
    props:{
        plan: {
            type: Object,
            required: true
        },
        cupom: {
            type: Object,
            required: true
        },
        forward: {
            required: true
        },
        activePrice: {
            default: null
        },
        change: {
            type: Boolean,
            default: false
        }
    },
    methods: {
	    normalizeSupport(support) {
            let totalSupport = 0;
            let cupomDiscount = this.cupom.discount;
            totalSupport = support - cupomDiscount;
            totalSupport = totalSupport.toFixed(2).replace(".", ",");
            return `R$ ${totalSupport}`;
        },
        normalizePriceDiscount(price) {
            return `R$ ${price}% Off`;
        },
        normalizeAmount(amount) {
            return amount.replace(".", ",");
        },
        calculateTotalPrice(plan) {
            let total = 0;
            let support = plan.support;
            let amount = plan.price_value;
            if (plan.price_cicle == 1 && plan.support > 0) {
                total = support - this.cupom.discount;
            } else {
                total = parseFloat(support) + parseFloat(amount) - this.cupom.discount;
                // total = total + plan.amount;
                // total = total.toFixed(2).replace(".", ",");
            }
            if (total < 0) {
                total = 0;
            }
            total = total.toFixed(2).replace(".", ",");
            return total;
        }
    }
}
</script>

<style>
	.plan-card {
		cursor: pointer;
		border: 2px solid transparent;
		padding: 15px;
        border-radius: 5px;
		box-shadow: 0 3px 6px 0px rgba(0, 0, 0, 0.16);
	}
	.plan-card .adesao--off {
		margin-left: 5px;
		margin-top: 6px;
		font-size: 0.62rem;
		color: var(--main-color);
		font-weight: 700;
	}
	.plan-card .de--por {
		margin-top: 6px;
		font-size: 0.62rem;
		margin-right: 5px;
	}
	.plan-card .message--mensalidade {
		font-size: 0.62rem;
		margin-left: 15px;
	}
	.plan-card.active {
		border: 2px solid var(--main-color);
	}
    .theme-color {
        color: var(--main-color);
    }
    .small--text--clean {
		font-size: 11px;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/molecules/PlanCard.vue